(function () {
if (window.__andLanding) return;
window.__andLanding = true;
var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
function reveal(root) {
var els = (root || document).querySelectorAll('[data-and-reveal]:not(.is-in)');
if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
var io = new IntersectionObserver(function (entries) {
entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
}, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
els.forEach(function (e) { io.observe(e); });
}
function counters(root) {
var els = (root || document).querySelectorAll('[data-and-count]:not([data-done])');
if (!els.length) return;
var run = function (el) {
el.setAttribute('data-done', '1');
var end = parseFloat(el.getAttribute('data-and-count')) || 0;
if (reduce || end === 0) { el.textContent = end; return; }
var t0 = null, dur = 1400;
function step(t) { if (!t0) t0 = t; var p = Math.min((t - t0) / dur, 1); var e = 1 - Math.pow(1 - p, 3); el.textContent = Math.round(end * e); if (p < 1) requestAnimationFrame(step); }
requestAnimationFrame(step);
};
if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
var io = new IntersectionObserver(function (entries) { entries.forEach(function (en) { if (en.isIntersecting) { run(en.target); io.unobserve(en.target); } }); }, { threshold: 0.4 });
els.forEach(function (e) { io.observe(e); });
}
var parallaxEls = [];
function collectParallax() { parallaxEls = Array.prototype.slice.call(document.querySelectorAll('[data-and-parallax]')); }
var ticking = false;
function onScroll() {
if (ticking || reduce) return; ticking = true;
requestAnimationFrame(function () {
var vh = window.innerHeight;
parallaxEls.forEach(function (el) {
var r = el.parentElement.getBoundingClientRect();
if (r.bottom < 0 || r.top > vh) return;
var p = (r.top + r.height / 2 - vh / 2) / vh;
el.style.transform = 'translateY(' + (p * -40).toFixed(1) + 'px)';
});
ticking = false;
});
}
document.addEventListener('input', function (e) {
if (!e.target.classList || !e.target.classList.contains('and-compare__range')) return;
var box = e.target.closest('[data-and-compare]');
if (box) box.style.setProperty('--pos', e.target.value + '%');
});
document.addEventListener('click', function (e) {
var btn = e.target.closest && e.target.closest('[data-and-force]');
if (!btn) return;
var sec = btn.closest('.and-force');
var mode = btn.getAttribute('data-and-force');
var viz = sec.querySelector('[data-and-force-viz]');
var tog = btn.closest('.and-toggle');
sec.querySelectorAll('[data-and-force]').forEach(function (b) { b.classList.toggle('is-on', b === btn); });
tog.classList.toggle('is-a', mode === 'brace');
viz.classList.toggle('is-brace', mode === 'brace');
viz.classList.toggle('is-strap', mode === 'strap');
var ca = sec.querySelector('[data-and-caption-brace]'), cb = sec.querySelector('[data-and-caption-strap]');
if (ca) ca.hidden = mode !== 'brace';
if (cb) cb.hidden = mode !== 'strap';
});
document.addEventListener('click', function (e) {
var a = e.target.closest && e.target.closest('[data-and-cta]');
if (!a) return;
var target = document.querySelector('[data-and-bundles]');
if (target) { e.preventDefault(); target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); }
});
function lazyVideos() {
var vids = document.querySelectorAll('video[data-and-lazyvideo]:not([data-loaded])');
if (!vids.length) return;
var load = function (v) {
v.setAttribute('data-loaded', '1');
v.querySelectorAll('source[data-src]').forEach(function (s) { s.src = s.getAttribute('data-src'); });
v.load(); var p = v.play(); if (p && p.catch) p.catch(function () {});
};
if (!('IntersectionObserver' in window)) { vids.forEach(load); return; }
var io = new IntersectionObserver(function (entries) { entries.forEach(function (en) { if (en.isIntersecting) { load(en.target); io.unobserve(en.target); } }); }, { rootMargin: '200px' });
vids.forEach(function (v) { io.observe(v); });
}
function init(root) { reveal(root); counters(root); collectParallax(); lazyVideos(); onScroll(); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
window.addEventListener('scroll', onScroll, { passive: true });
document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();